import { render, staticRenderFns } from "./firstAid.vue?vue&type=template&id=29378fe2&scoped=true&"
import script from "./firstAid.vue?vue&type=script&lang=js&"
export * from "./firstAid.vue?vue&type=script&lang=js&"
import style0 from "./firstAid.vue?vue&type=style&index=0&id=29378fe2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29378fe2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VContainer,VSelect})
